import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidenavService {
  private _isOpen: boolean = false;

  public close() {
    this._isOpen = false;
  }

  public toggle(): void {
    this._isOpen = !this._isOpen;
  }

  public get isOpened(): boolean {
    return this._isOpen;
  }

  public get isClosed(): boolean {
    return !this._isOpen;
  }
}
